export const DIFF_COLOR = '#25938B';
export const DIFF_BG_CLASSNAME = 'bg-green-100';
export const NORMAL_DIFF_CLASSNAME = 'text-green-diff-1';
export const DELETED_DIFF_CLASSNAME = `${NORMAL_DIFF_CLASSNAME} line-through`;
